import { Animated } from "react-animated-css";
import React, { Component, useState } from "react";
import * as firebase from "firebase";
import { Text, View, ActivityIndicator, Image, ScrollView } from "react-native";
import "firebase/firestore";
import { MyCart, Constant } from "./Data.js";
import logo from "./assets/favIcon.png";
import { AirbnbRating } from "react-native-ratings";
import { Container, Header, Content, CardItem, Body } from "native-base";
import { Rate, Input, Card, Select, Typography, notification } from "antd";
const { Meta } = Card;
const { Title } = Typography;
import "antd/dist/antd.css";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();

export default class SuccessScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const restaurantID = this.props.route.params.restaurantID;
    const orderID = this.props.route.params.orderID;
    const subTotalAmount = this.props.route.params.subTotalAmount;
    return (
      <View
        style={{
          flex: 1,
          marginTop: 16,
          marginLeft: 16,
          marginRight: 16,
          marginBottom: 16,
        }}
      >
        <Text
          style={{
            width: "100%",
            textAlign: "right",
            fontFamily: Constant.font,
            fontSize: 16,
            fontStyle: "italic",
            fontWeight: "bold",
          }}
        >
          FlyBy
        </Text>
        <View
          style={{
            flex: 1,
            flexGrow: 1,
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              style={{
                width: 50,
                height: 50,
              }}
              source={require("./assets/runningMan.png")}
            />
          </View>
          <SuccessElement />
          <ResRatingElement restaurantID={restaurantID} orderID={orderID} />
          <FlyByRatingElement restaurantID={restaurantID} orderID={orderID} />
        </View>
      </View>
    );
  }
}

function SuccessElement(props) {
  return (
    <View>
      <Text
        style={{
          fontFamily: Constant.font,
          fontSize: 18,
          fontWeight: "600",
          textAlign: "center",
        }}
      >
        Your Order is In{"\n"}& On the Way!
      </Text>
    </View>
  );
}

// cover={
//   <img
//     alt="example"
//     src="https://www.doctorswithoutborders.org/sites/default/files/styles/crop_7x3_full_width_hero/public/image_base_media/2020/04/MSF312629.jpg?itok=RSQWQZIr"
//   />
// }

// <DonationElement
//   restaurantID={restaurantID}
//   orderID={orderID}
//   subTotalAmount={subTotalAmount}
// />
function DonationElement(props) {
  const restaurantID = props.restaurantID;
  const orderID = props.orderID;
  const subTotalAmount = props.subTotalAmount;

  const [isDisabled, setIsDisabled] = useState(false);

  const handleChange = (value) => {
    return db
      .collection("Restaurants")
      .doc(restaurantID)
      .collection("Orders")
      .doc(orderID)
      .set(
        {
          donateTo: value,
        },
        { merge: true }
      );
  };
  const getDonationAmount = () => {
    let donationAmount = Constant.flyByFee * 0.5 * subTotalAmount;
    return donationAmount.toFixed(2);
  };
  return (
    <Card
      size="large"
      cover={
        <img
          alt="example"
          src="https://www.doctorswithoutborders.org/sites/default/files/styles/crop_7x3_full_width_hero/public/image_base_media/2020/04/MSF312629.jpg?itok=RSQWQZIr"
        />
      }
      style={{ width: "80%", marginTop: 32 }}
    >
      <Text>
        <Text style={{ fontWeight: "800", fontSize: 24 }}>
          ${getDonationAmount()}
        </Text>
        <Text> of this order supports:</Text>
      </Text>
      <Select
        onChange={handleChange}
        defaultValue="1"
        style={{ width: "100%", marginTop: 8, marginBottom: 8 }}
      >
        <Select.Option value="1">WHO COVID Solidarity Fund</Select.Option>
        <Select.Option value="2">St. Judes Children's Hospital</Select.Option>
        <Select.Option value="3">Black Lives Matter</Select.Option>
      </Select>
      <View style={{ justifyContent: "center" }}></View>
    </Card>
  );
  // <Text
  //   style={{
  //     color: "gray",
  //     fontSize: 13,
  //     fontWeight: "500",
  //     textAlign: "center",
  //   }}
  // >
  //   .
  // </Text>
}

function FlyByRatingElement(props) {
  const restaurantID = props.restaurantID;
  const orderID = props.orderID;

  const [isDisabled, setIsDisabled] = useState(false);
  let numHits = 0;

  const handleChange = (value) => {
    if (numHits > 4) {
      setIsDisabled(true);
    } else {
      numHits += 1;
      return db
        .collection("FlyBy-Ratings")
        .doc(orderID)
        .set({
          timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
          rating: value,
          restaurantID: restaurantID,
          orderID: orderID,
        });
    }
  };
  return (
    <Card
      size="small"
      title="Rate FlyBy:"
      style={{ width: "80%", marginTop: 24 }}
    >
      <Rate
        disabled={isDisabled}
        allowClear={false}
        style={{ fontSize: 24 }}
        onChange={handleChange}
      />
    </Card>
  );
}

function ResRatingElement(props) {
  const restaurantID = props.restaurantID;
  const orderID = props.orderID;

  const [isDisabled, setIsDisabled] = useState(false);
  let numHits = 0;

  const handleChange = (value) => {
    if (numHits > 4) {
      setIsDisabled(true);
    } else {
      numHits += 1;
      return db
        .collection("Restaurant-Ratings")
        .doc(orderID)
        .set({
          timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
          rating: value,
          restaurantID: restaurantID,
          orderID: orderID,
        });
    }
  };
  return (
    <Card
      size="small"
      title="Rate this Restaurant:"
      style={{ width: "80%", marginTop: 24 }}
    >
      <Rate
        disabled={isDisabled}
        allowClear={false}
        style={{ fontSize: 24 }}
        onChange={handleChange}
      />
    </Card>
  );
}
